// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1ZB9l","footer":"ModalUpdate_footer___KgZy"};